<template>
  <div class="vcheckbox" :class="{ checked: value, disabled }" @click="update(!value)"></div>
</template>

<script>
export default {
  name: 'Vcheckbox',

  props: ['value', 'disabled'],

  methods: {
    update(v) {
      if (!this.disabled) {
        this.$emit('input', v);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vcheckbox {
  display: flex;
  border-radius: 2px;
  min-width: 18px;
  max-width: 18px;
  min-height: 18px;
  max-height: 18px;
  border: 2px solid $grey;
  background-image: none;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.3s;
  outline: none;
  outline-width: 0;

  &:hover {
    background-color: $grey-light;
    transition: background 0.3s;
  }

  &:focus,
  &:active {
    outline: none;
    outline-width: 0;
  }
}

.vcheckbox.checked {
  background-image: url(/static/images/elements/vcv-checked.svg);
  background-color: $green;
  border: 2px solid $green;
  transition: background 0.3s;
}

.vcheckbox.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
